import { useSelector } from "react-redux";
import { AuthenticationState } from "../interfaces/users";
import { useMemo, useState } from "react";
import { hasNoPermission } from "../utils/helpers/userHelpers";
import { Assemblers } from "../modules/Assemblers/Assemblers";
import { Menu, MenuProps } from "antd";
import { Config } from "../modules/Assemblers/Config";

type MenuItem = Required<MenuProps>["items"][number];
export const AssemblersPage = () => {
  const { user } = useSelector((state: AuthenticationState) => state);
  const hasPermission = useMemo(() => hasNoPermission("assemble", user), [user]);
  const [current, setCurrent] = useState("config");

  const items: MenuItem[] = [
    {
      label: "Configuração",
      key: "config",
    },
    {
      label: "Montadores",
      key: "assemblers",
    },
  ];


  return (
    <>
      {hasPermission ? (
        <div>
          <Menu
            onClick={(e) => setCurrent(e.key)}
            selectedKeys={[current]}
            mode="horizontal"
            items={items}
          />

          {current === "assemblers" ? <Assemblers /> : null}
          {current === "config" ? <Config /> : null}
        </div>
      ) : (
        <div>O seu usuário não possui permissão para acessar este conteúdo</div>
      )}
    </>
  );
};
